var OnInputReason;
(function (OnInputReason) {
    OnInputReason["Close"] = "close";
    OnInputReason["Change"] = "change";
})(OnInputReason || (OnInputReason = {}));

export { OnInputReason };
